module.exports = __webpack_public_path__ + "static/img/checkexample.6bfd26d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/checkexample.png
// module id = qXyv
// module chunks = 1